import { render, staticRenderFns } from "./IcoDotPlusGrid.vue?vue&type=template&id=6efa4214"
import script from "./IcoDotPlusGrid.vue?vue&type=script&lang=js"
export * from "./IcoDotPlusGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports